import React, { useEffect, useRef, useState } from 'react'
import Title from './components/Title'
import CitiesFilters from './components/CitiesFilter'
import AddressesGroupsList from './components/AddressesGroupsList'
import { Center, City, Props, ViewState } from '../../types/AddressesGroup'
import { getGeoCenter, mapGoTo } from './functions'

const ShowAddresses: React.FC<Props> = (props: Props) => {
  const centers: Center[] = JSON.parse(props.centers).sort(
    (a: Center, b: Center) => a.listing_order - b.listing_order
  )
  const cities: City[] = JSON.parse(props.cities)
  const current_country = props.current_country
  const hostname = props.hostname
  const defaultCoordinates =
    current_country === 'BE'
      ? {
          // centered on Belgium coordinates
          latitude: 50.8,
          longitude: 4.38,
          zoom: 10.9,
        }
      : {
          // centered on France coordinates
          latitude: 45,
          longitude: 2.95,
          zoom: 5,
        }

  const MAPBOX_API_KEY = props.mapbox_api_key
  const MAPBOX_API_STYLE = props.mapbox_api_style

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const mapRef: any = useRef(null)

  const initialCityCenters = (citySlug: string) => {
    let initialCenters = centers
    cities.map((city: City) => {
      if (citySlug === `#${city.slug}`) {
        initialCenters = centers.filter(
          (element: Center) => element.address_group_id === city.id
        )
      }
    })
    return initialCenters
  }

  const [centersToDisplay, setCentersToDisplay] = useState<Center[]>(
    initialCityCenters(window.location.hash)
  )
  const [isBe, setIsBe] = useState(false)
  const [selectedCity, setSelectedCity] = useState<City | undefined>(undefined)
  const [isCorporation, setIsCorporation] = useState<boolean>(
    current_country == 'FR' ? false : true
  )
  const [isTopCfe, setIsTopCfe] = useState<boolean>(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [viewState, setViewState] = useState<ViewState>(defaultCoordinates)
  const [waitForMvt, setWaitForMvt] = useState(false)
  const [hashChanged, setHashChanged] = useState('')
  const [width, setWidth] = useState<number>(window.innerWidth)

  const isMobile = width <= 768
  const isTouch = width <= 1072
  window.addEventListener('hashchange', () =>
    setHashChanged(window.location.hash)
  )

  useEffect(() => {
    cities.map((city: City) => {
      if (window.location.hash === `#${city.slug}`) {
        setSelectedCity(city)
        let zoom = 10.5
        window.location.hash === '#ile-de-france' && (zoom = 8.75)
        setTimeout(() => {
          mapGoTo(getGeoCenter(centers, city), mapRef, zoom)
        }, 2000)
      }
    })
    current_country === 'BE' && setIsBe(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    cities.map((city: City) => {
      if (window.location.hash === `#${city.slug}`) {
        let zoom = 10.5
        window.location.hash === '#ile-de-france' && (zoom = 8.75)
        setWaitForMvt(true)
        mapGoTo(getGeoCenter(centers, city), mapRef, zoom)
        setSelectedCity(city)
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hashChanged])

  useEffect(() => {
    setCentersToDisplay(centers)
    if (selectedCity) {
      const centersOfSelectedCity = centers.filter(
        (element: Center) => element.address_group_id === selectedCity.id
      )
      setCentersToDisplay(centersOfSelectedCity)
    }
    if (isTopCfe) {
      const centersIsTopCfe = centersToDisplay.filter(
        (element: Center) => element.top_cfe
      )
      setCentersToDisplay(centersIsTopCfe)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCity, isTopCfe])

  useEffect(() => {
    window.addEventListener('resize', () => setWidth(window.innerWidth))
    return () => {
      window.removeEventListener('resize', () => setWidth(window.innerWidth))
    }
  }, [])

  return (
    <React.Fragment>
      <Title
        title="Trouvez votre adresse"
        subtitle={
          isBe
            ? 'Votre adresse de domiciliation en Belgique'
            : 'Plus de 60 adresses de domiciliation à Paris et partout en France'
        }
      />
      <CitiesFilters
        cities={cities}
        selectedCity={selectedCity}
        setSelectedCity={setSelectedCity}
        setIsCorporation={setIsCorporation}
        isCorporation={isCorporation}
        setIsTopCfe={setIsTopCfe}
        isTopCfe={isTopCfe}
        mapRef={mapRef}
        setCurrentPage={setCurrentPage}
        centers={centers}
        setWaitForMvt={setWaitForMvt}
        defaultCoordinates={defaultCoordinates}
        isBe={isBe}
        isMobile={isMobile}
        currentCountry={props.current_country}
      />

      <AddressesGroupsList
        mapRef={mapRef}
        centers={centersToDisplay}
        isCorporation={isCorporation}
        isTopCfe={isTopCfe}
        setViewState={setViewState}
        viewState={viewState}
        selectedCity={selectedCity}
        setSelectedCity={setSelectedCity}
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
        waitForMvt={waitForMvt}
        isBe={isBe}
        setWaitForMvt={setWaitForMvt}
        MAPBOX_API_KEY={MAPBOX_API_KEY}
        MAPBOX_API_STYLE={MAPBOX_API_STYLE}
        defaultCoordinates={defaultCoordinates}
        hostname={hostname}
        isTouch={isTouch}
      />
    </React.Fragment>
  )
}

export default ShowAddresses
